import React, { ReactElement } from "react";

interface Props {
  id: string;
  name: string;
  containerClass?: string;
  containerStyle?: React.CSSProperties;
  options: Array<{ key: string; value: string }>;
  selectedKey?: string | number;
  option?: { include_blank?: string };
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled?: boolean;
  required?: boolean;
  className?: string;
}

export default function SelectField(props: Props): ReactElement {
  const {
    containerClass = "w-full select-field-container",
    containerStyle,
    id,
    name,
    options,
    selectedKey,
    option = {},
    onChange,
    disabled,
    required,
    className = "px-4 py-2 bg-white border-2 border-quaternary rounded-full w-full cursor-pointer", // admin: w-full border p-2 rounded bg-white
  } = props;

  return (
    <div className={containerClass} style={containerStyle}>
      <select
        name={name}
        id={id}
        className={className}
        defaultValue={String(selectedKey)}
        onChange={(e) => {
          if (onChange !== undefined) {
            onChange(e);
          }
        }}
        disabled={disabled}
        required={required}
      >
        {option.include_blank !== undefined && (
          <option key="include_blank" label={option.include_blank} value="" />
        )}
        {options.map(({ key, value }) => (
          <option key={key} value={key}>
            {value}
          </option>
        ))}
        <optgroup label="" />
      </select>
    </div>
  );
}
